import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { homeRoute, loginRoute } from 'src/app/core/routing/route-names';
import { ActivationGuardBase } from './activation-guard.base';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard extends ActivationGuardBase {
  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  checkLogin(url: string): boolean {
    if (this.authService.isUserLoggedIn() && this.authService.isUserAdmin()) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    if (this.authService.isUserLoggedIn()) {
      this.router.navigate([homeRoute]);
    } else {
      this.router.navigate([loginRoute]);
    }
    return false;
  }
}
